
(function(){

	function resizeWindow(){

	}
	

	$(document).ready(function () {
		
		
		$('body#map #content').prepend('<a class="btn return-from-map" href="/ada-map">« Click Here For Accessible List Of Local Attractions</a>');
		$('body#map-category #content').prepend('<a class="btn return-from-map" href="/ada-map">« Click Here For Accessible List Of Local Attractions</a>');
		
		$('#start-content').addClass('loaded');
		setTimeout(function(){
			$('body').addClass('init');
		},300);

		//$('body#map #header, body#gallery #header').addClass('no-hero');
		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//$('.field.gdpr input').removeClass('required');

		

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		
		$('.book-now').on('click', function () {
			if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
		});
		//this class should be add to the header widget submit button
		$('.bookNow').on('click', function () {
			if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
		});

		//Check in and check out datepicker for booking engine
		$( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: 0,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		//let sideActive = 0;

		const $homeSide = $('.top-content-init .home-side');
		$homeSide.mouseover(function(){
			$homeSide.removeClass('hover out');
			$(this).addClass('hover');
			$(this).siblings().addClass('out');
			if($(this).hasClass('right-side')){
				$('.top-content-init').removeClass('left-over').addClass('right-over');
			}else{
				$('.top-content-init').removeClass('right-over').addClass('left-over');
			}
		});
		$homeSide.mouseleave(function(){
			$homeSide.removeClass('hover out');
			$('.top-content-init').removeClass('right-over left-over');
		});
		$homeSide.click(function(){
			const $this = $(this);
			$this.removeClass('inactive').addClass('active');
			$this.siblings().removeClass('active').addClass('inactive');
			$('.top-content-init').removeClass('right-over left-over');
			$this.siblings().find('.side-content').removeClass('active');
			setTimeout(function(){
				$this.find('.side-content').addClass('active');
			},700)
			if($this.hasClass('right-side')){
				$('.top-content-init').removeClass('left-active').addClass('right-active');
			}else{
				$('.top-content-init').removeClass('right-active').addClass('left-active');
			}
		});


		$('a').click(function(event){
			const thisHref = $(this).attr('href');
			if (thisHref.match("^#")) {
				event.preventDefault();
				const hrefTop = $(thisHref).offset().top;
				$('html,body').animate({scrollTop:hrefTop},1200);
			}
		});

		$('.sitemap-link').wrap("<li class='sitemap_link'></li>");
		$('.sitemap_link').appendTo('footer .sub-menu ul');

	});


	$(window).on('load', function(){ 
		setTimeout(function(){
			$('body').addClass('loaded');
			setTimeout(function(){
				$('body').addClass('loaded2');
			},600);
		},800);
	});

	$('svg').removeAttr('id');
}());